export const availableModules = [
    'home',
    'profile',
    'users',
    'groups',
    'companies',
    'tags',
    'types',
    'roles',
    'reports',
    'tickets',
    'channels',
    'settings',
    'contacts',
    'bots',
    'notifications',
    'customFields',
    'templates',
    'campaigns',
    'aiSettings',
    'tools',
    'records',
    'chatbots',
    'ia-tester',
    'users-tracking',
    'users-options',
    'bg-task',
    'monitoring',
    'interactions'
] as const;

export type AppModule = (typeof availableModules)[number];

// export enum AppModules {
//     DASHBOARD = 'DASHBOARD',
//     USERS = 'USERS',
//     GROUPS = 'GROUPS',
//     COMPANIES = 'COMPANIES',
//     TAGS = 'TAGS',
//     TYPES = 'TYPES',
//     PERMISSIONS = 'PERMISSIONS',
//     ROLS = 'ROLS',
//     TICKETS = 'TICKETS',
//
//
// }

// export enum ModuleAction {
//     CREATE = 'CREATE',
//     UPDATE = 'UPDATE',
//     DELETE = 'DELETE',
//     TO_LIST = 'TO_LIST',
//     DETAILS = 'DETAILS',
//     CREATE_AND_UPDATE = 'CREATE_AND_UPDATE',
//     DISABLE = 'DISABLE',
//     ENABLE = 'ENABLE',
//
//     //user
//     USERS_CHANGE_PASSWORD = 'USERS_CHANGE_PASSWORD',
//
//
// }

//Ticket Actions
export const availableTicketsActions = [
    'changeStatus',
    'changeStatusAdmin',
    'detailsAdmin',
    'assignMe',
    'transferTicket',
    'unAssignTicket',
] as const;

//Users actions
export const availableUsersActions = [
    'user_change_state',
] as const;

//Users Tracking actions
export const availableUsersTrackingActions = [
    'users_tracking_change_state',
] as const;

//Reports actions
export const availableReportsActions = [
    'reports_tickets_billing',
] as const;

//Companies actions
export const availableCompanyActions = [
    'company_custom_fields_add',
    'company_custom_fields_edit',
    'company_custom_fields_delete',

    'company_types_add',
    'company_types_edit',
    'company_types_delete',

    'company_tags_add',
    'company_tags_edit',
    'company_tags_delete',

    'company_ticket_states_bot_config',
    'company_ticket_states_operators_config',

    'company_chatbot_add',
    'company_chatbot_details',
    'company_chatbot_edit',
    'company_chatbot_import',
    'company_chatbot_export',
    'company_chatbot_test',
    'company_chatbot_remove',

    'company_chatbot_mono_general_data_tab_hidden',
    'company_chatbot_mono_prompt_tab_hidden',
    'company_chatbot_mono_rag_tab_hidden',
    'company_chatbot_mono_derivation_tab_hidden',
    'company_chatbot_mono_tools_tab_hidden',
    'company_chatbot_mono_ktags_tab_hidden',

    'company_chatbot_multi_general_data_tab_hidden',
    'company_chatbot_multi_prompt_tab_hidden',
    'company_chatbot_multi_assistant_tab_hidden',




    'company_integration_add',
    'company_integration_details',
    'company_integration_remove',
    'company_integration_edit',

    'company_templates_add',
    'company_templates_details',
    'company_templates_edit',
    'company_templates_remove',

    'company_campaigns_details',
    'company_campaigns_add',
    'company_campaigns_edit',
    'company_campaigns_remove',
    'company_campaigns_stats',
    'company_campaigns_report',

    'company_automations_add',
    'company_automations_details',
    'company_automations_edit',
    'company_automations_remove',

    'company_custom_responses_add',
    'company_custom_responses_details',
    'company_custom_responses_edit',
    'company_custom_responses_remove'

] as const;
//Chatbot Companies Actions
/*export const availableChatbotsActions = [
    'chatbotDetails',
    'chatbotAdd',
    'chatbotEdit',
    'chatbotDelete',
    'chatbotChangeStatus',
]*/
//Module Actions
export const availableModuleActions = [
    ...availableTicketsActions,
    ...availableUsersActions,
    ...availableUsersTrackingActions,
    ...availableReportsActions,
    ...availableCompanyActions,
    'create',
    'list',
    'update',
    'delete',
    'details',
    'disable',
    'enable',
] as const;

export type ModuleAction = (typeof availableModuleActions)[number];

export interface IModuleInfo {
    label: string;
    path: string;
    module: AppModule;
    availableActions: ModuleAction[];
}
